import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { GridIcon, LoopIcon, ShieldIcon, TrafficIcon } from './icons';
import './styles.scss';

const cards = [
  {
    key: 'safetyloop',
    tone: 'green',
    icon: ShieldIcon,
    title: 'SafetyLoop',
    body: 'The safety management platform — inspections, hazards, and the safety record your projects sit on.',
    href: 'https://www.safetyloop.com',
  },
  {
    key: 'projectloop',
    tone: 'orange',
    icon: LoopIcon,
    title: 'ProjectLoop',
    body: 'The project delivery platform — the eleven tools on this page.',
    hub: true,
  },
  {
    key: 'trafficloop',
    tone: 'amber',
    icon: TrafficIcon,
    title: 'TrafficLoop',
    body: 'Traffic control plans in minutes, not days. Drafted in the office, approved by the crew on site.',
    href: 'https://www.safetyloop.com/trafficloop',
  },
  {
    key: 'complyloop',
    tone: 'blue',
    icon: GridIcon,
    title: 'ComplyLoop',
    body: 'Compliance tracking across the companies and certs on your site.',
  },
];

export default function LoopFamilySection() {
  return (
    <section className="plh-family" id="family">
      <div className="plh-family__inner">
        <Reveal className="plh-family__copy">
          <p className="plh-eyebrow plh-eyebrow--light">One login, four Loops</p>
          <h2>
            Safety, traffic, compliance and delivery.{' '}
            <span className="plh-accent--light">One connected family.</span>
          </h2>
          <p className="plh-family__lede">
            ProjectLoop runs the project. SafetyLoop runs the safety program. TrafficLoop builds
            the traffic control plans. ComplyLoop runs compliance. One SSO login, one family of
            tools that already know each other.
          </p>
          <Link to="/pricing" className="plh-family__link">
            See family pricing <span aria-hidden="true">→</span>
          </Link>
        </Reveal>
        <div className="plh-family__grid">
          {cards.map((card, idx) => {
            const Icon = card.icon;
            const inner = (
              <>
                {card.hub && <span className="plh-family__badge plh-mono">You are here</span>}
                <span className="plh-family__icon" aria-hidden="true">
                  <Icon />
                </span>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </>
            );
            return (
              <Reveal
                className={`plh-family__card plh-family__card--${card.tone}${card.hub ? ' plh-family__card--hub' : ''}`}
                key={card.key}
                delay={idx * 90}
              >
                {card.href ? (
                  <a href={card.href} target="_blank" rel="noreferrer">
                    {inner}
                  </a>
                ) : (
                  inner
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
      <Reveal as="p" className="plh-family__foot plh-mono" delay={200}>
        SafetyLoop · ProjectLoop · TrafficLoop · ComplyLoop · Single sign-on
      </Reveal>
    </section>
  );
}
